<template>
  <div class="sa-video">
    <top-video
      :url="url"
      :cover-img="coverImg"
      @img-loaded="imgLoaded()"
    />
    <div
      v-if="afterImgLoad"
      class="vrResult"
    >
      <div class="sa-video-tit">
        {{ title }}
      </div>
      <div class="sa-video-info">
        <span>{{ nickName }}</span>
        <span>{{ publishTime }}</span>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.sa-video .sa-v-box {
    padding-bottom: 8px;
}

.sa-video .sa-v-box video {
    display: block;
}

.sa-video .sa-video-tit {
    font-size: 18px;
    line-height: 30px;
    color: #222;
    font-weight: bold;
}

.sa-video .sa-video-info{
    font-size: 14px;
    line-height: 22px;
    color: #999;
}
.sa-video .sa-video-info span+span {
    margin-left: 8px;
}

.sa-video .sm-flex .text-gray.ellipsis {
    padding-top: 4px;
}
.vrResult {
    position: relative;
    zoom: 1;
    padding: 12px 16px;
    background: #fff;
}
</style>
<script>
import { mapState } from 'vuex';

import TopVideo from './components/TopVideo';
export default {
  components: {
    TopVideo,
  },
  data() {
    return {
      afterImgLoad: false,
    };
  },
  computed: {
    ...mapState('savideo', ['videoInfo']),
    title() {
      return this.videoInfo && this.videoInfo.title;
    },
    url() {
      return this.videoInfo && this.videoInfo.link;
    },
    nickName() {
      return this.videoInfo && this.videoInfo.authorName;
    },
    publishTime() {
      return this.videoInfo && this.videoInfo.publishTime;
    },
    coverImg() {
      return this.videoInfo && this.videoInfo.poster;
    },
  },
  asyncData({ context, store, route, isClient }) {
    return store.dispatch('savideo/prefetchData', {
      context,
      store,
      route,
      isClient: !!isClient,
    });
  },
  mounted() {
    document.title = this.title;
  },
  methods: {
    imgLoaded() {
      this.afterImgLoad = true;
    },
  },
};
</script>
